<template>
	<div class="ss-content cirles-content">
		<div class="ss-container">
			<div class="ss-container__left_sm" >
				<div class="user-info">
					<img :src="userInfo.headImage | imgUrl" />
					<p class="username">{{userInfo.username}}</p>
				</div>
				<ul class="menu-list">
					<li v-for="(item, index) in menuList" :class="{active: menuIndex === index}" :key="index">
						<router-link :to="{name: item.value}">{{item.label}}</router-link>
					</li>
				</ul>
			</div>
			<div class="ss-container__right_big">
				<router-view />
			</div>
		</div>
	</div>
</template>

<script>
	import { mapActions } from 'vuex'
	export default {
		data() {
			return {
				menuIndex: 0,
				menuList: [
				// {
				// 	value: 'privateLetter',
				// 	label: '好友私信'
				// },
				{
					value: 'systemMessage',
					label: '系统私信'
				},
				{
					value: 'myCircles',
					label: '我的圈子'
				},
				{
					value: 'collection',
					label: '圈子收藏'
				},
				// {
				// 	value: 'interaction',
				// 	label: '我的互动'
				// }
			    ],
				userInfo: {}
			}
		},
		watch: {
			'$route.path': {
				handler: function(val, oldVal){
					let { name } = this.$route || {};
					this.menuIndex = this.menuList.findIndex(o => o.value === name);
				},
				deep: true,
				immediate: true
			}
		},
		created() {
			this.getUserInfo();
		},
		methods: {
			...mapActions('user', ['GetUserInfoHandle']),
			async getUserInfo() {
				this.userInfo = await this.GetUserInfoHandle(false);
			},
		}
	}
</script>

<style lang="scss">
	.cirles-content{
		padding-bottom: 140px;
		& > .ss-container{
			background-color: #fff;
			border:1px solid rgba(222,222,222,1);
		}
		.ss-container__left_sm{
			width: 208px;
			background:rgba(255,255,255,1);
			.user-info{
				padding: 12px 0 42px;
				img{
					width: 110px;
					height: 110px;
					display: block;
					margin: 0 auto;
					border-radius: 100%;
				}
			}
			.username{
				margin-top: 20px;
				font-size: 18px;
				font-weight: 400;
				color: #20292F;
				line-height: 20px;
				text-align: center;
			}
			.menu-list{
				border-top: 1px solid #DEDEDE;
				li{
					a{
						display: block;
						cursor: pointer;
						font-size:18px;
						font-weight:400;
						color:rgba(72,72,72,1);
						line-height:66px;
						text-align: center;
					}
					&.active a, &:hover a{
						background:rgba(26,112,254,1);
						color: #fff;
					}
				}
			}
		}
		.ss-container__right_big{
			min-height: 535px;
			border-left:1px solid rgba(222,222,222,1);
		}
		.right-navigation-box{
			position: absolute;
			bottom: -70px;
			left: -208px;
			right: 0;
		}
	}
</style>
